import {jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import {forwardRef,} from 'react'
import {Elevation} from '../styles/elevation'
import {PALETTE} from '../styles/paletteV3'
import {Radius} from '../types/constEnums'
import BaseButton, {} from './BaseButton'

const paletteColors = {
  gray: PALETTE.SLATE_200,
  warm: PALETTE.GOLD_500,
  pink: PALETTE.ROSE_500,
  mid: PALETTE.GRAPE_700,
  dark: PALETTE.SLATE_700,
  blue: PALETTE.SKY_500,
  white: '#FFFFFF'
} 

const buttonLightThemes = ['white', 'gray']

const StyledBaseButton = styled(BaseButton)(({
  palette = 'gray'
}) => {
  const backgroundColor = paletteColors[palette]
  const color = buttonLightThemes.includes(palette) ? PALETTE.SLATE_700 : '#FFFFFF'
  return {
    backgroundColor,
    borderRadius: Radius.BUTTON_PILL,
    color,
    fontWeight: 600,
    outline: 0
  }
})





const RaisedButton = forwardRef((props, ref) => {
  const {children, className, elevationPressed, elevationHovered, elevationResting} = props
  return (
    _jsx(StyledBaseButton, {
      ...props,
      className: className,
      elevationHovered: elevationHovered || Elevation.Z8,
      elevationResting: elevationResting || Elevation.Z2,
      elevationPressed: elevationPressed || Elevation.Z5,
      ref: ref,
 children: 
      children
    })
  )
})

export default RaisedButton
